import { ScaleType } from '@/types'

type SATScaleMap = Record<'Reading and Writing' | 'Math', Record<number, number>>

export const SAT_RW_SCALE: Record<number, number> = {
  54: 800,
  53: 780,
  52: 760,
  51: 730,
  50: 720,
  49: 710,
  48: 700,
  47: 690,
  46: 680,
  45: 660,
  44: 660,
  43: 650,
  42: 630,
  41: 630,
  40: 620,
  39: 610,
  38: 600,
  37: 590,
  36: 590,
  35: 580,
  34: 570,
  33: 560,
  32: 550,
  31: 540,
  30: 530,
  29: 520,
  28: 510,
  27: 510,
  26: 500,
  25: 490,
  24: 490,
  23: 470,
  22: 460,
  21: 440,
  20: 430,
  19: 410,
  18: 400,
  17: 390,
  16: 380,
  15: 360,
  14: 350,
  13: 340,
  12: 330,
  11: 310,
  10: 300,
  9: 290,
  8: 280,
  7: 270,
  6: 260,
  5: 250,
  4: 240,
  3: 230,
  2: 220,
  1: 210,
  0: 200,
}

export const SAT_MATH_SCALE: Record<number, number> = {
  44: 800,
  43: 790,
  42: 770,
  41: 750,
  40: 720,
  39: 700,
  38: 690,
  37: 680,
  36: 660,
  35: 650,
  34: 630,
  33: 620,
  32: 610,
  31: 600,
  30: 590,
  29: 580,
  28: 570,
  27: 560,
  26: 550,
  25: 540,
  24: 530,
  23: 520,
  22: 510,
  21: 500,
  20: 490,
  19: 480,
  18: 460,
  17: 450,
  16: 440,
  15: 430,
  14: 410,
  13: 400,
  12: 390,
  11: 380,
  10: 360,
  9: 350,
  8: 340,
  7: 320,
  6: 300,
  5: 280,
  4: 250,
  3: 240,
  2: 230,
  1: 220,
  0: 200,
}

export const SAT_SCALE: SATScaleMap = {
  'Reading and Writing': SAT_RW_SCALE,
  Math: SAT_MATH_SCALE,
}

export const SAT_SCORE_RANGE: ScaleType = {
  MIN: 200,
  MAX: 800,
  LOWER_BOUND: 400,
  UPPER_BOUND: 1600,
}
